/**
 * Teddly — Analytics Event Library
 * ─────────────────────────────────────────────────────────────────────────────
 * Provides a unified tcTrack() function that fires to:
 *   1. GA4      (window.gtag)
 *   2. Meta Pixel (window.fbq)
 *   3. dataLayer  (GTM-compatible)
 *
 * Called by: cart.js (add/remove/view-cart/checkout),
 *            inline scripts on product/collection pages (via analytics.liquid)
 * ─────────────────────────────────────────────────────────────────────────────
 */

(function (window) {
  'use strict';

  // ─── Safe wrappers ───────────────────────────────────────────────────────────
  function _gtag() {
    if (typeof window.gtag === 'function') window.gtag.apply(window, arguments);
  }
  function _fbq() {
    if (typeof window.fbq === 'function') window.fbq.apply(window, arguments);
  }
  function _dl(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // ─── Money helper (Shopify prices are in paise/cents) ───────────────────────
  function toRupees(paise) {
    return Math.round(Number(paise) / 100);
  }

  // ─── Build a GA4 item object from a Shopify cart line item ──────────────────
  function cartLineToItem(line, index) {
    return {
      item_id:       String(line.product_id || line.variant_id || ''),
      item_name:     line.product_title || line.title || '',
      item_variant:  (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : undefined,
      item_brand:    'Teddly',
      item_category: line.product_type || 'Soft Toys',
      price:         toRupees(line.price),
      quantity:      line.quantity || 1,
      currency:      'INR',
      index:         index || 0
    };
  }

  // ─── Core dispatcher ─────────────────────────────────────────────────────────
  /**
   * tcTrack(eventName, payload)
   *
   * Supported events (mirrors GA4 eCommerce spec):
   *   add_to_cart, remove_from_cart, view_cart,
   *   begin_checkout, purchase,
   *   select_item, view_item, view_item_list,
   *   search, view_promotion, select_promotion,
   *   sign_up, login, generate_lead
   *
   * payload shape: { items[], value, currency, ... }
   */
  window.tcTrack = function (eventName, payload) {
    payload = payload || {};
    var currency = payload.currency || 'INR';
    var value    = payload.value    || 0;
    var items    = payload.items    || [];

    // ── GA4 ──────────────────────────────────────────────────────────────────
    // switch (eventName) {

    //   case 'add_to_cart':
    //     _gtag('event', 'add_to_cart', { currency: currency, value: value, items: items });
    //     break;

    //   case 'remove_from_cart':
    //     _gtag('event', 'remove_from_cart', { currency: currency, value: value, items: items });
    //     break;

    //   case 'view_cart':
    //     _gtag('event', 'view_cart', { currency: currency, value: value, items: items });
    //     break;

    //   case 'begin_checkout':
    //     _gtag('event', 'begin_checkout', {
    //       currency: currency,
    //       value:    value,
    //       items:    items,
    //       coupon:   payload.coupon || undefined
    //     });
    //     break;

    //   case 'purchase':
    //     _gtag('event', 'purchase', {
    //       transaction_id: payload.transaction_id || '',
    //       affiliation:    'Teddly Online Store',
    //       value:          value,
    //       tax:            payload.tax    || 0,
    //       shipping:       payload.shipping || 0,
    //       currency:       currency,
    //       coupon:         payload.coupon  || undefined,
    //       items:          items
    //     });
    //     break;

    //   case 'select_item':
    //     _gtag('event', 'select_item', {
    //       item_list_id:   payload.item_list_id   || '',
    //       item_list_name: payload.item_list_name || '',
    //       items:          items
    //     });
    //     break;

    //   case 'search':
    //     _gtag('event', 'search', { search_term: payload.search_term || '' });
    //     break;

    //   case 'sign_up':
    //     _gtag('event', 'sign_up', { method: payload.method || 'email' });
    //     break;

    //   case 'login':
    //     _gtag('event', 'login', { method: payload.method || 'email' });
    //     break;

    //   case 'generate_lead':
    //     _gtag('event', 'generate_lead', { currency: currency, value: value });
    //     break;

    //   default:
    //     // Custom / future events — pass straight through
    //     _gtag('event', eventName, payload);
    //     break;
    // }

    // ── Meta Pixel mapping ───────────────────────────────────────────────────
    // switch (eventName) {

    //   case 'add_to_cart':
    //     _fbq('track', 'AddToCart', {
    //       content_ids:  items.map(function(i){ return i.item_id; }),
    //       content_name: items.length === 1 ? items[0].item_name : 'Multiple items',
    //       content_type: 'product',
    //       value:        value,
    //       currency:     currency,
    //       num_items:    items.reduce(function(s, i){ return s + (i.quantity || 1); }, 0)
    //     });
    //     break;

    //   case 'view_cart':
    //     _fbq('track', 'InitiateCheckout', {
    //       content_ids:  items.map(function(i){ return i.item_id; }),
    //       num_items:    items.reduce(function(s, i){ return s + (i.quantity || 1); }, 0),
    //       value:        value,
    //       currency:     currency
    //     });
    //     break;

    //   case 'begin_checkout':
    //     _fbq('track', 'InitiateCheckout', {
    //       content_ids:  items.map(function(i){ return i.item_id; }),
    //       num_items:    items.reduce(function(s, i){ return s + (i.quantity || 1); }, 0),
    //       value:        value,
    //       currency:     currency
    //     });
    //     break;

    //   case 'purchase':
    //     _fbq('track', 'Purchase', {
    //       content_ids:  items.map(function(i){ return i.item_id; }),
    //       content_type: 'product',
    //       value:        value,
    //       currency:     currency,
    //       num_items:    items.reduce(function(s, i){ return s + (i.quantity || 1); }, 0)
    //     });
    //     break;

    //   case 'sign_up':
    //     _fbq('track', 'CompleteRegistration', { status: true });
    //     break;

    //   case 'generate_lead':
    //     _fbq('track', 'Lead', { value: value, currency: currency });
    //     break;
    // }

    // ── dataLayer (GTM-compatible) ───────────────────────────────────────────
    var dlPayload = Object.assign({ event: eventName }, payload);
    if (items.length) dlPayload.ecommerce = { currency: currency, value: value, items: items };
    _dl(dlPayload);
  };

  // ─── Convenience: build item from product-card data attributes ────────────────
  window.tcItemFromCard = function (btn) {
    if (!btn) return null;
    var card = btn.closest('.tc-product-item') || btn.closest('.product-card-wrap');
    return {
      item_id:   btn.dataset.productId || btn.dataset.variantId || '',
      item_name: btn.dataset.productTitle || card && card.dataset.title || '',
      item_brand: 'Teddly',
      price:     parseFloat(btn.dataset.price || card && card.dataset.price || 0),
      quantity:  1,
      currency:  'INR'
    };
  };

  // ─── select_item: fire when a product card link is clicked ────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var card = link.closest('.tc-product-item, .product-card-wrap');
    if (!card) return;
    var item = {
      item_id:       card.dataset.productId || '',
      item_name:     card.dataset.title || link.textContent.trim(),
      item_brand:    'Teddly',
      item_category: card.dataset.type || 'Soft Toys',
      price:         parseFloat(card.dataset.price || 0),
      quantity:      1,
      currency:      'INR'
    };
    window.tcTrack('select_item', {
      item_list_id:   window._tcCurrentList || document.body.dataset.template || 'unknown',
      item_list_name: document.title,
      items:          [item]
    });
  });

  // ─── select_promotion: primary homepage hero CTA ───────────────────────────
  document.addEventListener('click', function (e) {
    var promotion = e.target.closest('[data-tc-promotion]');
    if (!promotion) return;
    window.tcTrack('select_promotion', {
      promotion_id: promotion.dataset.tcPromotion || 'brand_hero',
      promotion_name: 'Teddly brand hero'
    });
  });

  // ─── search: fire when search input is submitted (collection filter bar) ──────
  (function () {
    var searchInput = document.getElementById('tc-search');
    if (!searchInput) return;
    var lastQuery = '';
    searchInput.addEventListener('change', function () {
      var q = this.value.trim();
      if (q && q !== lastQuery && q.length >= 2) {
        lastQuery = q;
        window.tcTrack('search', { search_term: q });
      }
    });
  })();

  // ─── view_cart: fire when cart drawer is opened ───────────────────────────────
  (function () {
    var original = window.openCartDrawer;
    if (typeof original !== 'function') return;
    window.openCartDrawer = function () {
      original.apply(this, arguments);
      // Fetch current cart and fire event
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart) {
          if (!cart || !cart.items) return;
          var items = cart.items.map(cartLineToItem);
          window.tcTrack('view_cart', {
            currency: 'INR',
            value:    toRupees(cart.total_price),
            items:    items
          });
        })
        .catch(function(){});
    };
  })();

  // ─── begin_checkout: fire when "Checkout" button is clicked in cart drawer ────
  document.addEventListener('DOMContentLoaded', function () {
    var checkoutBtn = document.getElementById('checkout-btn');
    if (!checkoutBtn) return;
    checkoutBtn.addEventListener('click', function () {
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart) {
          if (!cart || !cart.items) return;
          var items = cart.items.map(cartLineToItem);
          window.tcTrack('begin_checkout', {
            currency: 'INR',
            value:    toRupees(cart.total_price),
            items:    items,
            coupon:   cart.cart_level_discount_applications &&
                      cart.cart_level_discount_applications.length
                        ? cart.cart_level_discount_applications[0].title
                        : undefined
          });
        })
        .catch(function(){});
    });
  });

})(window);
